var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"main"},[_c('img',{attrs:{"src":require("../static/img/404.png"),"alt":""}}),_c('p',[_vm._v("页面迷失在太空中......")])])])
}]

export { render, staticRenderFns }